<div class="lui-breadcrumbs-container">
  <ng-container *ngFor="let item of items; index as i">
    <div class="lui-breadcrumb-item">
      <ng-template [ngTemplateOutlet]="item.template"></ng-template>
    </div>

    <mat-icon svgIcon="chevron_right" *ngIf="i < items.length - 1"></mat-icon>
  </ng-container>
</div>
